// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-customer-billing-invoice-bank-info .BankText {
  margin: 25px 0;
}
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter {
  width: 100%;
  border-top: 2px solid black;
  padding-top: 10px;
}
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter .Left,
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter .Center,
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter .Right {
  width: 33%;
}
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter .Left div:first-child,
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter .Center div:first-child,
.fi-customer-billing-invoice-bank-info .InvoiceInfoFooter .Right div:first-child {
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/customer-billing/customer-billing-invoice/customer-billing-invoice-bank-info/customer-billing-invoice-bank-info.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;AAAR;AAEI;EACI,WAAA;EACA,2BAAA;EACA,iBAAA;AAAR;AACQ;;;EAGI,UAAA;AACZ;AAAY;;;EACI,gBAAA;AAIhB","sourcesContent":[".fi-customer-billing-invoice-bank-info {\r\n    .BankText {\r\n        margin: 25px 0;\r\n    }\r\n    .InvoiceInfoFooter {\r\n        width: 100%;\r\n        border-top: 2px solid black;\r\n        padding-top: 10px;\r\n        .Left,\r\n        .Center,\r\n        .Right {\r\n            width: 33%;\r\n            div:first-child {\r\n                margin-top: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
